import { BASE_URL_API } from "../../constants";
import fetcher from "../../utils/fetcher";

export const _api_get_factsheet = async ({ id_user }) => {
    return fetcher(`${BASE_URL_API}/user/${id_user}/profile/identity/form`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_put_factsheet = async ({ id_user, data }) => {
    return fetcher(`${BASE_URL_API}/user/${id_user}/profile/identity/form`, {
        method: "PUT",
        credentials: "include",
        body: JSON.stringify(data),
    });
};
